import { User } from 'lib/generated/graphql';
import Link from 'next/link';
import Avatar from 'src/shared-components/Avatar';

const DEFAULT_USER_AVATAR = process.env.DEFAULT_USER_AVATAR || '';

const InvitedUser = ({ user, referralType }: { referralType: string; user: User }) => (
  <div className={`lg:grid grid-cols-5`}>
    <div className="lg:col-start-1 col-end-2">
      <Link href={`/${user.username}`} passHref>
        <a data-testid="invited-user" className="flex flex-row items-center justify-start gap-x-2">
          <div>
            <Avatar
              size={'xxs'}
              roundness={'full'}
              image={user.photoUrl || DEFAULT_USER_AVATAR}
              username={user.username}
            />
          </div>
          <span className="font-medium text-md">{user.name}</span>
        </a>
      </Link>
    </div>
    <div className="lg:col-start-4 col-end-5">
      {referralType === 'FOUNDER' && (
        <div className="">
          {user.requestsCustomerOf && user.requestsCustomerOf.some(request => request.status === 'APPROVED') && (
            <div className="px-6 sm:px-0">
              <span className="font-medium text-md text-[#3B9F7B]">• Request Approved</span>
            </div>
          )}
          {!user.requestsCustomerOf.some(request => request.status === 'APPROVED') && (
            <div className="px-6 sm:px-0">
              <span className="font-medium text-md text-[#567BFC]">• Signed Up</span>
            </div>
          )}
        </div>
      )}
      {referralType === 'BUILDER' && (
        <div>
          {user.huddlesBuilderOf.length > 0 && (
            <div className="px-6 sm:px-0">
              <span className="font-medium text-md text-[#3B9F7B]">• Huddle Joined</span>
            </div>
          )}
          {user.huddlesBuilderOf.length === 0 && (
            <div className="px-6 sm:px-0">
              <span className="font-medium text-md text-[#567BFC]">• Signed Up</span>
            </div>
          )}
        </div>
      )}
    </div>
  </div>
);

/* 

builder
Signed Up - Pending: A builder has applied to be part of the community
  INIT
  PROFILE_1
  PROFILE_2
  TAGS
  INVITE_CODE_OR_WAITLIST
  INVITE_CODE_USED
  APPROVED
  DENIED
  REMOVED
  LEFT
  IMPORTED
  USERNAME
  UPLOAD_PROFILE_PIC
  COMPLETE

Huddle Joined: A builder is on a huddle that is Live
//
user.huddles_builder_of is > 0

For Founder Invites:
Pending: A founder has signed up
//

Success: A request has been approved
mapp over requests, see if any are approved 


*/

export default InvitedUser;
